import { render, staticRenderFns } from "./underConstruction.vue?vue&type=template&id=5f9942d9&scoped=true&"
import script from "./underConstruction.vue?vue&type=script&lang=js&"
export * from "./underConstruction.vue?vue&type=script&lang=js&"
import style0 from "./underConstruction.vue?vue&type=style&index=0&id=5f9942d9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9942d9",
  null
  
)

export default component.exports